import {get, patch} from '../utils/FetchAPI';

export const getConfig = () => get("/config/url-gg")
export const updateGGLink = (newURL) => patch("/config/urlGG", {newURL})